<template>
  <ul class="alphabet-list">
    <li class="item"
        v-for="item of letter"
        :key="item"
        :ref="item"
        @click="handelLetterClick"
        @touchstart.prevent="handleTouchStart"
        @touchmove="handleTouchMove"
        @touchend="handleTouchEnd"
    >
      {{item}}
    </li>
  </ul>
</template>

<script>
export default {
  name: "SchoolAlphabet",
  props: {
    cities: Object
  },
  data(){
    return {
      touchStatus: false,
      startY: 0,
      timer: null,
      firstLeter:""      
    }
  },
  updated () {
    //this.startY = this.$refs['C'][0].offsetTop
    this.startY =this.firstLeter;
  },
  computed: {
    letter () {
      const letters = []
      for (let i in this.cities) {     
        letters.push(i)
      }
      this.firstLeter=letters[0];
      return letters
    }
  },
  methods:{
    handelLetterClick (e) {
      // 向父组件触发事件
      this.$emit('change', e.target.innerText)
      // console.log(e.target.innerText)
    },
    handleTouchStart () {
      this.touchStatus = true
    },
    handleTouchMove (e) {
      if (this.touchStatus) {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          const touchY = e.touches[0].clientY - 79
          const index = Math.floor((touchY - this.startY) / 22)
          if (index >= 0 && index < this.letter.length) {
            this.$emit('change', this.letter[index])
          }
        }, 8)
      }
    },
    handleTouchEnd () {
      this.touchStatus = false
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/account/Alphabet.vue